// ENGLISH

export default {
    values: {
        'VARIABLE VALUE': 'VARIABLE VALUE',
        'VARIABLE NAME': 'VARIABLE NAME',
        'Choose an environment variable for your LIVE applications': 'Choose an environment variable for your LIVE applications',
        'Environment properties': 'Environment properties',
        'Environment properties settings': 'Environment properties settings',
        'New variable': 'New variable',
        'Variable name': 'Variable name',
        'Variable value': 'Variable value'
    }
}
